import { Avatar, Button } from '@vechaiui/react';
import { parsePhoneNumber } from 'awesome-phonenumber';
import { useLocalization } from '@fluent/react';

const ContactPointCard: React.FC<ContactPointCardProps> = ({ avatarUrl, name, telephone }) => {
  const { l10n } = useLocalization();
  const phoneNumber = telephone ? parsePhoneNumber(telephone) : undefined;

  return (
    <div className="flex gap-6 items-center">
      <div className="flex-1 flex items-center gap-4">
        {avatarUrl && <Avatar src={avatarUrl} size="2xl" />}

        <div>
          <span className="block">{name}</span>
          {phoneNumber?.valid && <span className="block">{phoneNumber.number.international}</span>}
        </div>
      </div>

      {phoneNumber?.valid && (
        <div>
          <a href={phoneNumber.number.rfc3966}>
            <Button className="rounded-full" size="sm" color="green">
              {l10n.getString('call')}
            </Button>
          </a>
        </div>
      )}
    </div>
  );
};
export type ContactPointCardProps = {
  avatarUrl?: string;
  name: string;
  telephone?: string;
};

export default ContactPointCard;
